// extracted by mini-css-extract-plugin
export default {"form":"In4Pi","inner":"TDtO0","actions":"IQ2TB","action":"v80ui"};